export default __webpack_public_path__ + "static/result_mob_img-948f9e199155ad2edc224dd20311cf1c.png";